import Images from '@assets/images';
import { Accordion, Chip, Typography } from '@components/base';
import { Avatar } from '@components/common';
import { useState } from 'react';
import css from './index.module.scss';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import Footer from '../components/footer';
import UploadLCDetailsCard from './components';
import { Link } from 'react-router-dom';

interface uploadLCDetailsProps {
  taskData: Partial<ITaskTabProps>;
  onComplete?: () => void;
}

const LCDetailsCard = (props: uploadLCDetailsProps) => {
  const { taskData } = props;
  const [openModal, setopenModal] = useState(false);
  const getCompleteStatus = taskData?.is_completed || false;
  const [taskIsCompleted, setTaskIsCompleted] = useState<boolean>(getCompleteStatus);
  const handleStatusFromModal = (data: boolean) => {
    setTaskIsCompleted(data);
  };

  return (
    <>
      <div className={css.mainWrapper}>
        <Accordion defaultExpanded>
          <Accordion.Header className={css.accordionHeader}>
            <div className={css.header}>
              <div className={css.wrapper}>
                {getCompleteStatus || taskIsCompleted ? (
                  <Avatar src={Images.alertSuccessFaint} alt="" />
                ) : (
                  <Avatar src={Images.illustration} alt="" />
                )}
                <Link to={`/order/${taskData?.order}`} style={{ textDecoration: 'none' }}>
                  <Typography variant="h5" className={css.underlineOnHover}>
                    #{taskData?.readable_task_id} - Upload LC Details
                  </Typography>
                </Link>
              </div>
              <div className={css.pocWrapper}>
                {!getCompleteStatus && taskIsCompleted === false && (
                  <Chip
                    label="Add Details"
                    variant="outlined"
                    clickable={true}
                    className={css.uploadButton}
                    onClick={() => setopenModal(true)}
                  />
                )}
              </div>
            </div>
          </Accordion.Header>
        </Accordion>
        <Footer
          createdDate={props.taskData?.created_at as Date}
          updatedDate={props.taskData?.updated_at as Date}
        />
        {openModal && (
          <UploadLCDetailsCard
            open={openModal}
            onClose={() => setopenModal(false)}
            sendStatusToCard={handleStatusFromModal}
            taskId={taskData.task_id as string}
            onComplete={props.onComplete}
          />
        )}
      </div>
    </>
  );
};

export default LCDetailsCard;
